import Vue from 'vue'
import VueRouter from 'vue-router'
import Criacao from '@/pages/criacao'
import Login from '@/pages/login'
import Home from '@/pages/home'

Vue.use(VueRouter)

const router = new VueRouter({
  scrollBehavior() {
    return { x: 0, y: 0 }; 
  },
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/agenda'
    },
    {
      path: '/agenda',
      name: 'home',
      component: Home,
    },
    {
      path: '/agenda/login',
      name: 'login',
      component: Login
    },
    {
      path: '/agenda/criar',
      name: 'criar',
      component: Criacao
    }
  ]
})

export default router;